import { createAsyncThunk } from '@reduxjs/toolkit';
import getAllOems from 'services/oems/getAllOems';

export const getAllOemsAction = createAsyncThunk('oems/getAllOems', async () => {
  const oems = await getAllOems();

  return { oems };
});
